import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { getTheme } from "./theme/theme";
import { QueryClient, QueryClientProvider } from "react-query";

LicenseInfo.setLicenseKey(
  "01075c7c4b913a6632eb522e496fd4eaT1JERVI6MjcwMzUsRVhQSVJZPTE2NTc3MzE3NzAwMDAsS0VZVkVSU0lPTj0x"
);
const queryClient = new QueryClient();
const app = (
  <React.StrictMode>
    <ThemeProvider theme={getTheme("light")}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
ReactDOM.render(app, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
